import { useParams } from 'react-router-dom';

export const useGetReleaseIdFromParams = () => {
  const { id } = useParams();
  return id ? parseInt(id, 10) : undefined;
};
